<template>
    <q-drawer 
        bordered
        side="right" 
        :breakpoint="800"
        :model-value="open"
        @update:model-value="(val) => { $emit('update:open', val); }"
        :behavior="$q.screen.width > 800 ? 'desktop' : 'mobile'"
        :class="{ 'bg-grey-1': !$q.dark.isActive }"
        @before-show="NotificationStore.fetch()"
    >
        <template v-if="NotificationStore.count ?? false">
            <q-scroll-area style="height: calc(100% - 50px);">
                <q-list separator>
                    <q-intersection 
                        v-for="(noto, i) in NotificationStore.data"
                        :key="i"
                        transition="fade"
                        style="min-height: 70px;"
                    >
                        <q-slide-item
                            :key="`${noto.id}-${i}-${noto.nonce}`"
                            :left-color="notificationMeta(noto.type).color"
                            @left="(d) => { NotificationStore.markAsRead(noto.id); d.reset(); }"
                            :loading="NotificationStore.loading"
                            right-color="blue-grey-6"
                            @right="(d) => { $inertia.visit(noto.link); d.reset(); }"
                        >
                            <template #left>
                                <div class="row items-center">
                                    <q-icon right name="mdi-check" class="q-mr-sm" /> Mark as read
                                </div>
                            </template>
                            <template v-if="noto.link" #right>
                                <div class="row items-center">
                                    Open Link <q-icon name="mdi-link" class="q-ml-sm" />
                                </div>
                            </template>
                            <q-item
                                :class="{
                                    'q-pa-none': 1,
                                    'bg-transparent': $q.dark.isActive,
                                    [`bg-grey-${i % 2 == 0 ? 1 : 2}`]: !$q.dark.isActive && i % 2 == 0,
                                }"
                            >
                                <q-separator 
                                    vertical
                                    style="width: 5px;"
                                    :color="notificationMeta(noto.type).color"
                                />
                                <q-item-section avatar class="q-px-md text-center">
                                    <q-icon 
                                        :color="notificationMeta(noto.type).color"
                                        :name="notificationMeta(noto.type).icon"
                                    />
                                </q-item-section>
                                <q-item-section class="q-py-sm q-pr-sm">
                                    <q-item-label>
                                        {{noto.text}}
                                    </q-item-label>
                                    <q-item-label caption>
                                        <q-badge v-if="noto.link" color="blue-grey-6">
                                            <q-icon name="mdi-link" />
                                            <q-tooltip class="bg-blue-grey-6">
                                                Slide right to open link
                                            </q-tooltip>
                                        </q-badge>
                                        {{formatDistance(noto.created_at)}}
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-slide-item>
                    </q-intersection>

                    <q-item v-if="NotificationStore.count > NotificationStore.paginationData.rowsPerPage">
                        <q-item-section class="text-center">
                            <q-btn
                                flat
                                no-caps
                                :disable="NotificationStore.loading"
                                :color="NotificationStore.loading ? 'grey-5' : 'primary'"
                                :label="NotificationStore.loadMoreText"
                                @click="NotificationStore.fetchNext(true)"
                            />
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-scroll-area>

            <q-separator style="margin-top: auto;" />

            <q-item class="q-pa-none text-center">
                <q-item-section class="no-wrap q-pa-none">
                    <q-btn
                        flat
                        no-caps
                        v-if="NotificationStore.count > 0"
                        label="Mark all as read"
                        color="primary"
                        @click="NotificationStore.markAllAsRead()"
                        style="height: 48px;"
                    />
                </q-item-section>
            </q-item>
        </template>
        <div v-else class="text-center text-grey-5 q-my-lg" style="font-size: 1rem;">
            <q-icon name="mdi-bell-off" size="1.2rem" /> No Notifications Found
            <div class="text-grey-4" style="font-size: 0.8rem">No news is good news</div>
        </div>

        <q-inner-loading :showing="NotificationStore.loading">
            <q-spinner
                color="primary"
                size="3em"
            />
        </q-inner-loading>
    </q-drawer>
</template>

<script>
import { useNotificationStore } from '@/Stores/NotificationStore.js';

export default {
    name: 'NotificationsSidebar',
    setup() {
        const NotificationStore = useNotificationStore();

        return {
            NotificationStore,
        };
    },
    props: {
        open: Boolean,
    },
    methods: {
        notificationMeta(type) {
            switch (type) {
                case 'warning':
                    return { icon: 'mdi-alert', color: 'warning' };
                case 'info':
                    return { icon: 'mdi-information', color: 'info' };
                case 'success':
                    return { icon: 'mdi-check-circle', color: 'positive' };
                case 'error':
                    return { icon: 'mdi-alert-circle', color: this.$q.dark.isActive ? 'red-5' : 'negative' };
                default:
                    return { icon: 'mdi-bell', color: 'grey-9' };
            }
        },
    },
}
</script>